import Button from '@bufferapp/ui/Button'
import styled from 'styled-components'

export const RemoveScheduleButton = styled.button`
  margin-left: 8px;
  cursor: pointer;
`

export const ButtonStyled = styled(Button)`
  margin-right: 10px;
  & div[aria-expanded='true'] div:nth-child(2) {
    width: 240px;
    max-width: 240px;
  }
`
